import { render, staticRenderFns } from "./SportEnSpel.vue?vue&type=template&id=6eae2d70&"
import script from "./SportEnSpel.vue?vue&type=script&lang=js&"
export * from "./SportEnSpel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports